import {
  getSpectras, postSpectra, putSpectra, exportSpectras, importSpectras,
} from '../../../Api/services/backoffice';

export const key = 'spectra';

const entityName = {
  singular: 'Spectra',
  plural: 'Spectras',
};

const queries = {
  list: { key, fn: getSpectras },
  detail: { key },
};

const mutations = {
  create: postSpectra,
  update: putSpectra,
};

const fields = {
  table: [
    { key: 'affiliateTraitFrom.affiliate.name', label: 'Filial de' },
    { key: 'affiliateTraitFrom.trait.name', label: 'Traço de' },
    { key: 'AffiliateTraitTo.affiliate.name', label: 'Filial para' },
    { key: 'AffiliateTraitTo.trait.name', label: 'Traço para' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportSpectras,
  importFn: importSpectras,
};
